<template>
    <section class="employee-map-calendar-layout">
        <div class="employee-map-left-filters" v-if="!hideFilters">
            <div class="d-md-none my-3 ms-1 bg-white">
                <a class="map-left-filter-toggler p-1" role="button" @click="toggleMapLeftFilters()">
                    <i
                        class="fas"
                        :title="!hideMapLeftFilters ? 'Open side nav' : 'Close side nav'"
                        :class="!hideMapLeftFilters ? 'fa-angle-double-left' : 'fa-angle-double-right'"
                    ></i>
                </a>
            </div>
            <div class="map-left-top-filters" v-show="!hideMapLeftFilters">
                <div class="filter">
                    <span class="fw-bold pb-1 label">Organization</span>
                    <MultiSelect
                        classes="first-btn"
                        :dropDownOptions="agencyMultiSelectOptions"
                        labelText="Organizations"
                        :resetToSelectAllProp="resetToSelectAllBranches"
                        :selectedOptions="selectedAgencies"
                        v-on:updateBranches="updateBranches"
                    />
                </div>
                <div class="filter">
                    <span class="fw-bold pb-1 label">Branches</span>
                    <BranchDefaultFilter
                        classes="first-btn"
                        :check-all-by-default="true"
                        :selected-branches="selectedBranches"
                        v-on:updateBranches="handleBranchesOnChange"
                        :selected-agencies-name="selectedAgenciesName"
                    />
                </div>
                <div class="filter" v-if="isEmployeeCalendar">
                    <span class="fw-bold pb-1 label">Credentials</span>
                    <MultiSelectFilter
                        classes="first-btn"
                        :on-fetch="userCredentialsFetch"
                        :selectedItems="selectedCredentials"
                        v-on:selectedItemsUpdated="selectedItemsUpdated"
                        name="User Credentials"
                    />
                </div>

                <div class="filter" v-if="isEmployeeCalendar">
                    <span class="fw-bold pb-1 label">Status</span>
                    <VisitStatusMultiSelect
                        :selectedItems="selectedVisitStatus"
                        :options="statusList"
                        v-on:selectedItemsUpdated="selectedVisitStatusUpdated"
                    />
                </div>
                <div class="filter" v-if="isPatientCalendar && listView === CalendarViewTypeEnum.Map">
                    <span class="fw-bold pb-1 label"> Location</span>
                    <MultiSelectFilter
                        classes="first-btn"
                        :on-fetch="selectLocationFetch"
                        :selectedItems="selectedLocations"
                        v-on:selectedItemsUpdated="selectedLocationsUpdated"
                        :fetchUpdatedCount="fetchUpdatedCount"
                        placeholder="Search for Locations"
                        name="Locations"
                    />
                </div>

                 <div class="filter" v-if="isPatientCalendar && listView === CalendarViewTypeEnum.Map">
                <span class="fw-bold pb-1 label">Case Manager</span>
                <MultiSelectFilter
                   classes="first-btn"
                   :on-fetch= "caseManagerFetch"
                   :selectedItems="selectedCaseManagers"
                   v-on:selectedItemsUpdated="selectedCaseManagersUpdated"
                   :custom-message="'Select Case Manager'"
                   placeholder="Search Case Managers"

                />
            </div>
                <div class="filter" v-if="isPatientCalendar">
                    <div class="fw-bold pb-1 label">Status</div>
                    <select
                        class="form-select pl-1 first-btn"
                        name="patient-status"
                        v-model="selectedPatientStatus"
                        @change="handlePatientStatusChange"
                    >
                        <option :value="null">All</option>
                        <option v-for="item of patientStatusEnums" :value="item.value" :key="item.value">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="action-buttons d-flex pt-1 justify-content-end">
                    <button
                        type="button"
                        :disabled="!isBranchesloaded || isMapVisitsListLoading"
                        class="btn btn-xs btn-outline-primary mx-2"
                        @click="clearFilters()"
                    >
                        Clear
                    </button>
                    <button
                        type="button"
                        class="btn btn-xs btn-primary"
                        :disabled="!isBranchesloaded || isMapVisitsListLoading"
                        @click="isPatientCalendar ? emitPatientMapRefresh() : emitMapRefresh()"
                    >
                        Generate
                    </button>
                </div>
            </div>
            <div class="map-left-bottom-filters" v-show="!hideMapLeftFilters">
                <div class="text-center py-2" ref="trigger" v-if="isMapVisitsListLoading">
                    <i class="fas fa-spinner fa-pulse fa-fw fa-2x"></i>
                    <div>Loading...</div>
                </div>
                <div
                    v-if="!isMapVisitsListLoading && employees.length"
                    v-for="emp of employees"
                    :key="`${emp.name}-${emp.value}`"
                    @click="
                        (e) =>
                            isEmployeeCalendar ? selectedEmployeesUpdated([emp], e) : selectedPatientsUpdated([emp], e)
                    "
                    :class="`emp-details  ${isSelected(emp.value) ? 'active' : ''} `"
                >
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">
                            <p class="mb-0 w-auto user-name fw-bold me-1">
                                {{ emp.name.split("+")[0] }}
                            </p>
                            <span class="text-break">{{ isEmployeeCalendar ? emp.credential : "" }}</span>
                        </div>
                        <button
                            type="button"
                            class="btn px-1 py-0 ms-1 btn-outline-primary icon-size align-self-start"
                            data-bs-toggle="dropdown"
                            id="UnassignedRow__Actions${id}"
                        >
                            <i class="fas fa-ellipsis-h icon-size"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="UnassignedRow__Actions${id}">
                            <a
                                class="dropdown-item"
                                :id="`task-manager-${emp.value}`"
                                href="javascript:void(0);"
                                @click="
                                    (e) =>
                                        isEmployeeCalendar ? openTaskManager(e, emp) : openPatientTaskManager(e, emp)
                                "
                            >
                                Task Manager
                            </a>

                            <a
                                class="dropdown-item"
                                href="javascript:void(0);"
                                :id="`profile-${emp.value}`"
                                v-if="isPatientCalendar"
                                @click="(e) => openProfile(e, emp)"
                            >
                                Profile
                            </a>
                        </div>
                    </div>
                    <p class="w-100 font-size-2xs text-truncate mb-0">{{ emp.agencyName }}</p>
                    <span
                        :class="`fw-normal font-size-xs badge badge-pill pill mr-1 ${productClass.toView(
                            emp.application
                        )}`"
                    >
                        {{ ApplicationNameEnum[emp.application] }}
                    </span>
                </div>
                <div class="d-flex justify-content-center" v-if="!isMapVisitsListLoading && !employees.length">
                    <p>No Tasks Found</p>
                </div>
            </div>
        </div>
        <div class="employee-map-content">
            <div class="map-right-top-filters" v-if="!hideFilters">
                <div class="mx-auto mx-md-0">
                    <DailyDateNavigation :startDate="mapDate" :endDate="mapDate" v-on:taskRefresh="mapDateUpdate" />
                </div>
                <div class="filter employee-search" v-if="isEmployeeCalendar">
                    <MultiSelectFilter
                        classes="first-btn"
                        :on-fetch="selectEmployeeFetch"
                        :selectedItems="selectedEmployees"
                        v-on:selectedItemsUpdated="selectedEmployeesUpdated"
                        :fetchUpdatedCount="fetchUpdatedCount"
                        placeholder="Search for Employees by Name"
                        name="Employees"
                        :isCalendar="true"
                        :isMap="true"
                    />
                </div>
                <div class="filter" v-if="isPatientCalendar">
                    <MultiSelectFilter
                        classes="first-btn"
                        :on-fetch="selectPatientFetch"
                        :selectedItems="selectedPatients"
                        v-on:selectedItemsUpdated="selectedPatientsUpdated"
                        :fetchUpdatedCount="fetchUpdatedCount"
                        placeholder="Search for Patients by Name"
                        name="Patients"
                        :isCalendar="true"
                        :isMap="true"
                    />
                </div>
                <div class="filter mx-auto mx-md-0">
                    <div class="list-view-btn" v-if="hasTestAgency">
                        <button
                            :class="`btn weekly-view ${
                                listView == CalendarViewTypeEnum.Weekly || listView == CalendarViewTypeEnum.Daily
                                    ? 'active'
                                    : ''
                            }`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Weekly)"
                        >
                            Calendar
                        </button>

                        <button
                            :class="`btn map-view${isEmployeeCalendar ? '-emp' : ''} ${listView == CalendarViewTypeEnum.Map ? 'active' : ''}`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Map)"
                        >
                            Map
                        </button>
                        <button
                            v-if="isEmployeeCalendar"
                            :class="`btn summary-view ${listView == CalendarViewTypeEnum.SummaryView ? 'active' : ''}`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.SummaryView)"
                        >
                            Summary
                        </button>
                    </div>
                    <div class="list-view-btn" v-else>
                        <button
                            :class="`btn weekly-view ${
                                listView == CalendarViewTypeEnum.Weekly || listView == CalendarViewTypeEnum.Daily
                                    ? 'active'
                                    : ''
                            }`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Weekly)"
                        >
                            Calendar
                        </button>

                        <button
                            :class="`btn map-view ${listView == CalendarViewTypeEnum.Map ? 'active' : ''}`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Map)"
                        >
                            Map
                        </button>
                    </div>
                </div>
            </div>
            <div class="map-visits" v-if="isEmployeeCalendar && mapVisitsList?.length > 0">
                <EmployeeVisitMap :mapVisitsList="mapVisitsList" :date="mapDate" v-on:mapRefresh="emitMapRefresh" />
            </div>
            <div class="patient-map-visits" v-else-if="!isEmployeeCalendar && mapVisitsList?.length > 0">
                <PatientVisitMap
                    :mapVisitsList="mapVisitsList"
                    :date="mapDate"
                    v-on:mapRefresh="emitPatientMapRefresh"
                    v-model:hideFilters="hideFilters"
                    :isPremiumByAgency="isPremiumByAgency"
                />
            </div>
            <div v-else class="img-map-container">
                <img class="me-1" src="../../../../../assets/images/default-map-usa.png" />
            </div>
        </div>
    </section>
</template>

<style src="./EmployeeMap.scss"></style>
<script src="./EmployeeMap.ts"></script>
